import React, { useState, Component ,useEffect }  from 'react';
import { Button ,Modal,Spin,Form,Input,Row,Col,Select,message } from 'antd';
import { useHistory } from 'react-router-dom';
import LinkButton,{ClickButton} from '../../components/link-button';
import {reqAddAccount,reqEnums,reqActiveMail} from '../../api';
import CryptoJS from 'crypto-js';
import logo from '../../assets/image/logo.png'
import './regist.less';

const validatePassword = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }else{
        const letterCount = (value.match(/[a-zA-Z]/g) || []).length;
        const numberCount = (value.match(/\d/g) || []).length;
        if (letterCount < 1 || numberCount < 1 || value.length < 6 || value.length > 15) {
          return Promise.reject(new Error("英文字と数字を含む、6-15桁文字で入力してください。"));
        }
        return Promise.resolve();
    }
    
  };


const RegistForm = () => {
    const [form] = Form.useForm();
    const [registDisabled, setRegistDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [enums, setEnums] = useState({});
    const [registMail, setRegistMail] = useState('');
    const [countdown, setCountdown] = useState(0);
    const history = useHistory();
  


    useEffect(() => {
        const fetchEnums = async () => {
            const result = await reqEnums();
            if (result.status === 0) {
                setEnums(result.data);
            }
        };
        fetchEnums();

        let timer;
        if (countdown > 0) {
        timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);
        }

        return () => {
            if (timer) clearInterval(timer);
        };
    }, [countdown]);
  
    const formValuesChange = () => {
        setErrorMsg('')
        setTimeout(() => {
            const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0);
            const values = form.getFieldValue();
            setRegistDisabled(hasErrors || 
                            values.mailAddress.trim() === "" || 
                            values.firstName.trim() === "" || 
                            values.secondName.trim() === "" || 
                            values.password.trim() === "" || 
                            values.IFA === undefined || 
                            values.annualIncome === undefined || 
                            values.housingCosts === undefined);

          }, 100);
      };

    const onRegistFinish = async (values) => {
        const { password} = values    
        setLoading(true)
        values.password = CryptoJS.SHA256(password).toString();
        const result =  await reqAddAccount(values)
        if (result.status===0) { 
            setRegistMail(values.mailAddress)
        }else{
            if  (result.data.name !== undefined){
                form.setFields([result.data]);
            }else{
                setErrorMsg(result.data)
            }
        }
        setLoading(false)
    };
    const loginClick=()=>{
        history.push('/login');
    }

    
    const SendActiveMail=async ()=>{  
        setLoading(true)
        const result = await reqActiveMail(registMail);
        if (result.status === 0) {
            message.success('メールを送信しました。')
            setCountdown(60); 

        }else{
            message.error(result.data)
        }
        setLoading(false)
    }
  
      const spinStyle = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          zIndex: 1000,
          overflow: 'auto',
      };
  
    return (
      <>
      <Modal
        style={{
            top: 0,
            }}
          title={null}
          footer={null}
          visible={true}   
          maskClosable={false}
          closable={false}
          maskStyle={{ backgroundColor: 'white' }}
        >
        {loading && <div style={spinStyle}>
                        <Spin spinning={loading} size="large" />
                        </div>}
                        {registMail === '' && <Form
                        layout="vertical"
                        form={form}
                        onValuesChange={formValuesChange}
                        name="request"
                        className="login-form"
                        initialValues={{ remember: false }}
                        onFinish={onRegistFinish}
                        >
                        <Form.Item>
                            <div className="login-header" >
                                <img  src={logo} alt=''></img>
                                <div className="title">アカウント登録</div>
                            </div>
                        </Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label={<span className='login-form-title'>姓</span>}
                                    name="firstName"
                                    rules={[{ required:true, message:"入力は必須です。" }]}
                                    initialValue="">
                                    <Input className="login-form-item"/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                    <Form.Item
                                    label={<span className='login-form-title'>名</span>}
                                    name="secondName"
                                    rules={[{ required:true, message:"入力は必須です。" }]}
                                    initialValue="">
                                    <Input className="login-form-item"/>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item 
                            label={<span className='login-form-title'>メールアドレス</span>}
                            name='mailAddress'
                            rules={[{ required:true, message:"入力は必須です。" },
                                    { type:'email', message:"有効なメールアドレスを入力してください。" }]}
                            initialValue="">
                            <Input className="login-form-item"/>
                        </Form.Item>

                        <Form.Item
                            label={<span className='login-form-title'>パスワード</span>}
                            name="password"
                            rules={[{ required:true, message:"入力は必須です。" },
                                    { validator: validatePassword }]}
                            initialValue="">
                            <Input.Password className="login-form-item"/>
                        </Form.Item>

                        {enums['IFAID'] && <Form.Item 
                            label={<span className='login-form-title'>アドバイザーID</span>}
                            name='IFA'
                            rules={[{ required:true, message:"入力は必須です。" }]}
                            >
                            <Select className="login-form-item" placeholder="選択してください">
                                {enums['IFAID'].map((v) => (
                                    <Select.Option key={v.id} value={v.Code}>{v.Name}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>}

                        
                        {enums['AnnualIncome'] && <Form.Item 
                            label={<span className='login-form-title'>年収</span>}
                            name='annualIncome'
                            rules={[{ required:true, message:"入力は必須です。" }]}
                            >
                            <Select className="login-form-item" placeholder="選択してください">
                                {enums['AnnualIncome'].map((v) => (
                                    <Select.Option key={v.id} value={v.Code}>{v.Name}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>}
                        
                        {enums['HousingCosts'] && <Form.Item 
                            label={<span className='login-form-title'>居住費支払い種別</span>}
                            name='housingCosts'
                            rules={[{ required:true, message:"入力は必須です。" }]}
                            >   
                            <Select className="login-form-item" placeholder="選択してください">
                                {enums['HousingCosts'].map((v) => (
                                    <Select.Option key={v.id} value={v.Code}>{v.Name}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>}

                        <Form.Item className="login-form-error">
                            <span >{errorMsg}</span>
                        </Form.Item>
                        <Form.Item >
                            <Button type="primary" htmlType="submit" className="login-form-button" disabled={registDisabled}>
                            新規登録
                            </Button>
                        </Form.Item>
                        

                        <Form.Item >
                                <div>
                                    <span style={{marginLeft:'5px'}}>アカウントが既にありますか？</span>
                                    <LinkButton onClick={loginClick}>ログイン</LinkButton>
                                </div>
                        </Form.Item>
                    </Form>}
                    {registMail !== '' && <Form
                        layout="vertical"
                        name="confirm"
                        className="login-form"
                        >
                        <Form.Item>
                            <div className="login-header" >
                                <img  src={logo} alt=''></img>
                                <div className="title">メールの確認</div>
                            </div>
                        </Form.Item>
                        
                        <Form.Item style={{ fontSize:'12px'}}>
                            
                        <div><span>アクティベーションメールを送信しました。</span></div>
                        <div><span>下記のメールアドレスに届いたメールを確認し、アカウントを有効化してください。</span></div>
                        <div><span><strong>{registMail}</strong></span></div>
                            
                        </Form.Item>


                        <Form.Item >
                            <ClickButton onClick={SendActiveMail} disabled={countdown > 0}>{countdown > 0 ? `${countdown} 秒後に再送信可能` : '確認メールを再送信'}</ClickButton>
                        </Form.Item>
                        
                        <Form.Item >
                            <LinkButton onClick={loginClick}>ログインページに戻る</LinkButton>
                        </Form.Item>
                    </Form>}
        </Modal>        
        </>
    );
  }

export default class Regist extends Component {

    render() {
        document.title = 'アカウント登録'
      return (
            <RegistForm />        
      );
    }
  }
  



